import React from 'react';
import { TrendingUp, Users, Eye, Clock } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
const viewData = [{
  name: 'Week 1',
  views: 400
}, {
  name: 'Week 2',
  views: 300
}, {
  name: 'Week 3',
  views: 550
}, {
  name: 'Week 4',
  views: 800
}];
const inquiryData = [{
  name: 'Duplex',
  inquiries: 12
}, {
  name: 'Land',
  inquiries: 8
}, {
  name: 'Apt',
  inquiries: 15
}];
const sourceData = [{
  name: 'Direct',
  value: 400
}, {
  name: 'Search',
  value: 300
}, {
  name: 'Social',
  value: 300
}];
const COLORS = ['#0E4B3C', '#C8A24A', '#9CA3AF'];
export const SellerAnalytics = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-1401">
      <div data-id="element-1402">
        <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1403">
          Performance Analytics
        </h1>
        <p className="text-text-light" data-id="element-1404">
          Track how your listings are performing on AMU.
        </p>
      </div>

      {/* KPI Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1405">
        {[{
        label: 'Total Views',
        value: '2,450',
        icon: Eye,
        trend: '+12%',
        positive: true
      }, {
        label: 'Inquiry Rate',
        value: '4.2%',
        icon: Users,
        trend: '+1.1%',
        positive: true
      }, {
        label: 'Avg Time on Listing',
        value: '2m 15s',
        icon: Clock,
        trend: '-5s',
        positive: false
      }, {
        label: 'Top District',
        value: 'Maitama',
        icon: TrendingUp,
        trend: 'Tier 1',
        positive: true
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-neutral-200" data-id="element-1406">
              <div className="flex justify-between items-start mb-4" data-id="element-1407">
                <div className="w-10 h-10 rounded-xl bg-neutral-100 flex items-center justify-center text-primary-900" data-id="element-1408">
                  <Icon size={20} data-id="element-1409" />
                </div>
                <span className={`text-xs font-bold px-2 py-1 rounded ${stat.positive ? 'bg-success/10 text-success' : 'bg-neutral-200 text-neutral-dark'}`} data-id="element-1410">
                  {stat.trend}
                </span>
              </div>
              <div className="text-2xl font-bold text-text mb-1" data-id="element-1411">
                {stat.value}
              </div>
              <div className="text-xs font-bold text-text-light uppercase tracking-wider" data-id="element-1412">
                {stat.label}
              </div>
            </div>;
      })}
      </div>

      {/* Charts */}
      <div className="grid lg:grid-cols-2 gap-6" data-id="element-1413">
        {/* Views Line Chart */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-neutral-200" data-id="element-1414">
          <h3 className="font-bold text-text mb-6" data-id="element-1415">Listing Views (30 Days)</h3>
          <div className="h-64" data-id="element-1416">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1417">
              <LineChart data={viewData} data-id="element-1418">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f5f5f5" data-id="element-1419" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#9CA3AF'
              }} data-id="element-1420" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#9CA3AF'
              }} data-id="element-1421" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }} data-id="element-1422" />
                <Line type="monotone" dataKey="views" stroke="#0E4B3C" strokeWidth={3} dot={{
                r: 4,
                fill: '#0E4B3C',
                strokeWidth: 2,
                stroke: '#fff'
              }} activeDot={{
                r: 6
              }} data-id="element-1423" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Inquiries Bar Chart */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-neutral-200" data-id="element-1424">
          <h3 className="font-bold text-text mb-6" data-id="element-1425">Inquiries per Listing</h3>
          <div className="h-64" data-id="element-1426">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1427">
              <BarChart data={inquiryData} data-id="element-1428">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f5f5f5" data-id="element-1429" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#9CA3AF'
              }} data-id="element-1430" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#9CA3AF'
              }} data-id="element-1431" />
                <Tooltip cursor={{
                fill: '#f5f5f5'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }} data-id="element-1432" />
                <Bar dataKey="inquiries" fill="#C8A24A" radius={[4, 4, 0, 0]} data-id="element-1433" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Traffic Sources Donut */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-neutral-200 lg:col-span-2" data-id="element-1434">
          <h3 className="font-bold text-text mb-6" data-id="element-1435">Traffic Sources</h3>
          <div className="h-64 flex items-center justify-center" data-id="element-1436">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1437">
              <PieChart data-id="element-1438">
                <Pie data={sourceData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1439">
                  {sourceData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-1440" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }} data-id="element-1441" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute flex gap-6 mt-32" data-id="element-1442">
              {sourceData.map((entry, index) => <div key={index} className="flex items-center gap-2 text-sm" data-id="element-1443">
                  <div className="w-3 h-3 rounded-full" style={{
                backgroundColor: COLORS[index]
              }} data-id="element-1444"></div>
                  <span className="text-text-light" data-id="element-1445">{entry.name}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};